import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  SubmissionsByTask,
  TasksLength,
  Project,
} from '../page_components/PoolDetails/Missions/types'
import {
  selectCurrentProject,
  selectTaskSubmissions,
} from '../modules/missionControl/selectors'

import { reduceToTasksLength } from './useMissionControlPoolStateManagement'
import useFetchAndUpdateDropTaskSubmissions from './useUpdateDropTaskSubmissions'

const useMissionControlDropStateManagement = () => {
  const currentProject = useSelector(selectCurrentProject)
  const taskSubmissions = useSelector(selectTaskSubmissions)

  const fetchAndUpdateInformation = useFetchAndUpdateDropTaskSubmissions()

  useEffect(() => {
    fetchAndUpdateInformation()
  }, [fetchAndUpdateInformation])

  const tasksLength: TasksLength = useMemo(
    () =>
      reduceToTasksLength(
        currentProject as Project,
        taskSubmissions ?? ({} as SubmissionsByTask),
      ),
    [currentProject, taskSubmissions],
  )

  return {
    currentProject,
    taskSubmissions,
    tasksLength,
    fetchAndUpdateInformation,
  }
}

export default useMissionControlDropStateManagement
